import React from 'react';
import { AppModal } from '../common';

export interface SimpleModalProps {
  open?: boolean;
  hide?: () => void;
  title: string;
  content: string;
  variant?: ComponentVariant;
  footer?: any;
}

export const SimpleModal: React.FC<SimpleModalProps> = ({
  hide,
  title,
  content,
  open = false,
  footer = null,
  variant = 'nurture',
}) => {

  return (
    <AppModal
      width="90%"
      variant={variant}
      footer={footer}
      onCancel={hide}
      open={open}
      title={title}
      style={{ maxWidth: '850px', maxHeight: '70%' }}
    >
      <div dangerouslySetInnerHTML={{ __html: content }}></div>
    </AppModal>
  );
};

export default SimpleModal;
